import styled from 'styled-components';

const H5 = styled.span`
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    font-family: ${props => props.font === "" ? "Lato" : props.font};
    color: ${props => props.color ?? "#3A3C40"};
`;

export default H5;